import React from 'react';
import PropTypes from 'prop-types';
import { BulkSelectionContext } from './BulkSelection';

export const BulkSelectionConsumer = ({
  consumerCompName = 'BulkSelectionConsumer',
  providerCompName = 'BulkSelection',
  children,
}) => {
  return (
    <BulkSelectionContext.Consumer>
      {context => {
        return children(context);
      }}
    </BulkSelectionContext.Consumer>
  );
};

BulkSelectionConsumer.propTypes = {
  children: PropTypes.any,
  consumerCompName: PropTypes.string,
  providerCompName: PropTypes.string,
};
